"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartAxisZoomSliderThumb = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var React = _interopRequireWildcard(require("react"));
var _styles = require("@mui/material/styles");
var _useForkRef = _interopRequireDefault(require("@mui/utils/useForkRef"));
var _useEventCallback = _interopRequireDefault(require("@mui/utils/useEventCallback"));
var _rafThrottle = require("@mui/x-internals/rafThrottle");
var _clsx = _interopRequireDefault(require("clsx"));
var _chartAxisZoomSliderThumbClasses = require("./chartAxisZoomSliderThumbClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["className", "onMove", "orientation", "placement", "rx", "ry"];
const Rect = (0, _styles.styled)('rect')(({
  theme
}) => ({
  [`&.${_chartAxisZoomSliderThumbClasses.chartAxisZoomSliderThumbClasses.root}`]: {
    fill: theme.palette.mode === 'dark' ? (theme.vars || theme).palette.grey[300] : (theme.vars || theme).palette.common.white,
    stroke: theme.palette.mode === 'dark' ? (theme.vars || theme).palette.grey[600] : (theme.vars || theme).palette.grey[500]
  },
  [`&.${_chartAxisZoomSliderThumbClasses.chartAxisZoomSliderThumbClasses.horizontal}`]: {
    cursor: 'ew-resize'
  },
  [`&.${_chartAxisZoomSliderThumbClasses.chartAxisZoomSliderThumbClasses.vertical}`]: {
    cursor: 'ns-resize'
  }
}));
/**
 * Renders the zoom slider thumb, which is responsible for resizing the zoom range.
 * @internal
 */
const ChartAxisZoomSliderThumb = exports.ChartAxisZoomSliderThumb = /*#__PURE__*/React.forwardRef(function ChartAxisZoomSliderThumb(_ref, forwardedRef) {
  let {
      className,
      onMove,
      orientation,
      placement,
      rx = 4,
      ry = 4
    } = _ref,
    rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const classes = (0, _chartAxisZoomSliderThumbClasses.useUtilityClasses)({
    onMove,
    orientation,
    placement
  });
  const thumbRef = React.useRef(null);
  const ref = (0, _useForkRef.default)(thumbRef, forwardedRef);
  const onMoveEvent = (0, _useEventCallback.default)(onMove);
  React.useEffect(() => {
    const thumb = thumbRef.current;
    if (!thumb) {
      return;
    }
    const onPointerMove = (0, _rafThrottle.rafThrottle)(event => {
      onMoveEvent(event);
    });
    const onPointerUp = () => {
      thumb.removeEventListener('pointermove', onPointerMove);
      thumb.removeEventListener('pointerup', onPointerUp);
    };
    const onPointerDown = event => {
      // Prevent text selection when dragging the thumb
      event.preventDefault();
      event.stopPropagation();
      thumb.setPointerCapture(event.pointerId);
      thumb.addEventListener('pointerup', onPointerUp);
      thumb.addEventListener('pointermove', onPointerMove);
    };
    thumb.addEventListener('pointerdown', onPointerDown);

    // eslint-disable-next-line consistent-return
    return () => {
      thumb.removeEventListener('pointerdown', onPointerDown);
      onPointerMove.clear();
    };
  }, [onMoveEvent, orientation]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Rect, (0, _extends2.default)({
    className: (0, _clsx.default)(classes.root, className),
    ref: ref,
    rx: rx,
    ry: ry
  }, rest));
});
if (process.env.NODE_ENV !== "production") ChartAxisZoomSliderThumb.displayName = "ChartAxisZoomSliderThumb";